import type { FC } from "react";
import { Outlet } from "react-router-dom";

const TaskDefinitionsRoute: FC = () => {
  return (
    <div className="flex-1 flex flex-col rounded-xl bg-background gap-y-2 mt-4 p-4">
      <Outlet />
    </div>
  );
};

export default TaskDefinitionsRoute;
